// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1461) return "static/chunks/1461-89df323e34ad5e3d.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bf7c7fbd093dfb04" + ".js";
};